"use strict";
exports.__esModule = true;
exports.toSignOperationEventRaw = exports.fromSignOperationEventRaw = exports.toSignedOperationRaw = exports.fromSignedOperationRaw = void 0;
var account_1 = require("../account");
var fromSignedOperationRaw = function (signedOp, accountId) {
    var operation = signedOp.operation, signature = signedOp.signature, expirationDate = signedOp.expirationDate, signatureRaw = signedOp.signatureRaw;
    var out = {
        operation: (0, account_1.fromOperationRaw)(operation, accountId),
        signature: signature,
        expirationDate: expirationDate ? new Date(expirationDate) : null
    };
    if (signatureRaw) {
        out.signatureRaw = signatureRaw;
    }
    return out;
};
exports.fromSignedOperationRaw = fromSignedOperationRaw;
var toSignedOperationRaw = function (signedOp, preserveSubOperation) {
    var operation = signedOp.operation, signature = signedOp.signature, expirationDate = signedOp.expirationDate, signatureRaw = signedOp.signatureRaw;
    var out = {
        operation: (0, account_1.toOperationRaw)(operation, preserveSubOperation),
        signature: signature,
        expirationDate: expirationDate ? expirationDate.toISOString() : null
    };
    if (signatureRaw) {
        out.signatureRaw = signatureRaw;
    }
    return out;
};
exports.toSignedOperationRaw = toSignedOperationRaw;
var fromSignOperationEventRaw = function (e, accountId) {
    switch (e.type) {
        case "signed":
            return {
                type: "signed",
                signedOperation: (0, exports.fromSignedOperationRaw)(e.signedOperation, accountId)
            };
        default:
            return e;
    }
};
exports.fromSignOperationEventRaw = fromSignOperationEventRaw;
var toSignOperationEventRaw = function (e) {
    switch (e.type) {
        case "signed":
            return {
                type: "signed",
                signedOperation: (0, exports.toSignedOperationRaw)(e.signedOperation, true)
            };
        default:
            return e;
    }
};
exports.toSignOperationEventRaw = toSignOperationEventRaw;
//# sourceMappingURL=signOperation.js.map